'use strict';

const i18n = require('i18next');
const _ = require('underscore');
const Mn = require('backbone.marionette');
const TypeaheadView = require('common/ui/view/typeahead');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const Template = require('common/ui/template/group/member-search.hbs');
const ItemTemplate = require('common/ui/template/group/member-item.hbs');

const DropdownItemView = TypeaheadView.DropdownItemView.extend({
    tagName: 'li',
    template: ItemTemplate,
    className: 'list-item',
    activeClass: 'is-active',
    regions: {
        icon: '.member-icon',
        name: '.member-name',
    },
    templateContext: function() {
        return {
            roleName: i18n.t(`group-role.${this.model.getRole()}`),
        };
    },
    onRender: function() {
        this.showChildView('icon', new GroupMemberIconView({
            model: this.model
        }));
        this.showChildView('name', new GroupMemberNameView({
            model: this.model
        }));
    }
});

/**
 * Group Member 検索・選択用の View
 *
 * コンストラクタには `{group: group}` として Group を設定して下さい。
 * View を表示すると input が作成されるので、そこにカーソルを当てることで
 * Group Member の一覧が表示されます(利用停止中のユーザーは除外)。
 *
 * `exclude` プロパティに Group Member を引数にとる function(member) を
 * 設定することができます。
 *
 * `exclude` が true を返す場合はその Group Member は検索結果から除かれるので、
 * 既に選択済みの Member を除外して表示するといった使い方が可能です。
 *
 * クリックまたはキーボードで Group Member が選択されると、
 * `select` イベントが発火します。
 * 第一引数には Group Member が設定されます。
 */
module.exports = Mn.View.extend({
    template: Template,
    exclude: null,

    onRender: function() {
        const group = this.getOption('group');
        const members = group.getMembers();
        const exclude = this.getOption('exclude');

        this._typeaheadView = new TypeaheadView({
            showOnFocus: true,
            el: this.$('input'),
            find: function (query) {
                let c = members.chain();
                query = query.toLowerCase();
                if(query != '') {
                    c = c.filter(m => m.getUser().getName().toLowerCase().indexOf(query) > -1)
                }

                if(exclude) {
                    c = c.filter(m => !exclude(m));
                }

                return c.value();
            },
            // Dropdown が選択された時に呼ばれる
            update: member => {
                this.triggerMethod('select', member);
                return '';
            },
            // itemView は DropdownItemView を使って作成
            itemView: DropdownItemView,
            minLength: 0
        });
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/group/member-search.js